import addToDataLayerBatch from '../helpers/batchPush';
import type { PromotionEcommerceType, TrackingEventType, ViewPromotionType } from './types/types';

export default function trackViewPromotion({
    ecommerce,
    trackingType
}: { ecommerce: PromotionEcommerceType; trackingType: TrackingEventType }) {
    if (!window.dataLayer) {
        window.dataLayer = [];
    }

    const result: ViewPromotionType = {
        event: 'view_promotion',
        $type: trackingType,
        ecommerce
    };

    addToDataLayerBatch(result);
}
